import ACTIVE_WEB_VERSION_PANEL from './activeWebVersion';

export const CURRENT_WEB_VERSION = ACTIVE_WEB_VERSION_PANEL.replace(/^v/, '');

const seenKey = (userId) => `conecta__seenWebVersion__${userId}`;

export function readStoredUserData() {
  try {
    const raw = localStorage.getItem('conecta__userData');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function shouldAutoOpenVersionPopup(userData = readStoredUserData()) {
  if (!userData?.id) return false;
  if (userData.showNewWebVersion) return true;
  return localStorage.getItem(seenKey(userData.id)) !== CURRENT_WEB_VERSION;
}

export function markCurrentWebVersionSeen(userData = readStoredUserData()) {
  if (!userData?.id) return;
  localStorage.setItem(seenKey(userData.id), CURRENT_WEB_VERSION);
}
